import { createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { WorkOSActions, WorkOSActionTypes } from '../_actions/workOS.actions';
import { QueryParamsModel } from '../../_base/crud';
import { WorkOS } from '../_models/workOS.model';

export interface WorkOSsState extends EntityState<WorkOS> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedWorkOSId: number;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<WorkOS> = createEntityAdapter<WorkOS>();

export const initialWorkOSsState: WorkOSsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedWorkOSId: undefined,
  showInitWaitingMessage: true,
});

export function workOSsReducer(state = initialWorkOSsState, action: WorkOSActions): WorkOSsState {
  switch (action.type) {
    case WorkOSActionTypes.WorkOSsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedWorkOSId: undefined,
      };
    case WorkOSActionTypes.WorkOSsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case WorkOSActionTypes.WorkOSCreated:
      return adapter.addOne(action.payload.workOS, {
        ...state,
        lastCreatedWorkOSId: action.payload.workOS.id,
      });
    case WorkOSActionTypes.WorkOSUpdated:
      return adapter.updateOne(action.payload.partialWorkOS, state);
    case WorkOSActionTypes.WorkOSsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case WorkOSActionTypes.WorkOSsPageLoaded: {
      return adapter.addMany(action.payload.workOSs, {
        ...initialWorkOSsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
        error: null,
      });
    }
    case WorkOSActionTypes.ThrowWorkOSError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case WorkOSActionTypes.FireWorkOSSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getWorkOSState = createFeatureSelector<WorkOSsState>('workOSs');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
